export default __webpack_public_path__ + "static/media/webeggs.d1b09c97.png";